import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { IDepartments } from "redux/reducers/models/product";

//GET Departments
export async function GetDepartments(params: { extended: boolean }, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<IDepartments[]>(
    APIUrl(AdminType.FacilityAdmin, "/facility/department"),
    params,
    useGlobalLoader,
    token,
  );
}

export interface IDepartmentDeleteEligibility {
  has_products: boolean;
  has_category_children: boolean;
  has_subcategory_children: boolean;
}

export async function GetDepartmentDeleteEligibility(
  params: { id: number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<IDepartmentDeleteEligibility>(
    APIUrl(AdminType.FacilityAdmin, "/facility/department/delete-eligibility"),
    params,
    useGlobalLoader,
    token,
  );
}

//POST Departments
export async function PostDepartments(params: Omit<IDepartments, "id">, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/department"), params, useGlobalLoader);
}

//PUT Departments
export async function PutDepartments(params: IDepartments, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/department"), params, useGlobalLoader);
}

//DELETE Departments
export async function DeleteDepartments(params: IDepartments, useGlobalLoader?: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/department"), params, useGlobalLoader);
}

export interface IDepartmentProductSettings {
  id: number;
  vendor?: any;
  vendor_id?: number | null;
  accounting_reference?: any;
  accounting_reference_id?: string | number | null;
  customer_required?: boolean;
  fulfillment_required?: boolean;
  shipping_required?: boolean;
  track_inventory?: boolean;
  cannot_be_sold?: boolean;
  online_store?: boolean;
  product_unit_id?: number | null;
  tax_exempt?: boolean;
  tax_line_ids?: number[];
}

//PUT Department Products
export async function UpdateAllDepartmentProducts(params: IDepartmentProductSettings, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/department/products"), params, useGlobalLoader);
}

interface IGetDepartmentDefaults {
  department_id: number;
}

export async function GetDepartmentDefaults(params: IGetDepartmentDefaults, useGlobalLoader?: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/department/defaults"), params, useGlobalLoader);
}

export interface IDepartmentDefaults {
  id: number;
  vendor_id?: number;
  vendor_title?: string;
  customer_required?: boolean;
  shipping_required?: boolean;
  fulfillment_required?: boolean;
  accounting_reference_id?: number;
  track_inventory?: boolean;
  type?: string;
  tax_exempt?: boolean;
  kitchen_location_id?: number;
  kitchen_location_id_2?: number;
  kitchen_location_id_3?: number;
  cannot_be_sold?: boolean;
  online_store?: boolean;
  product_unit_id?: number;
  tax_line_ids?: number[];
}

export async function PutDepartmentDefaults(params: IDepartmentDefaults, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/department/defaults"), params, useGlobalLoader);
}
